import React from 'react'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { settingsService } from '@/lib/services/settings'

// Store-level opt-in gate for the FOH Food Safety module. The fohTasks
// subscription feature is checked by PrivateRoute; this checks the per-store
// Settings toggle and bounces to /foh when it's off.
export default function FohFoodSafetyGate({ children }: { children: React.ReactNode }) {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
  })
  if (isLoading) return null
  if (!settings?.fohFoodSafety?.enabled) return <Navigate to="/foh" replace />
  return <>{children}</>
}
